import { Icon, InputAdornment, TextField } from "@material-ui/core";
import React, { useState } from "react";
import { mask, unMask } from "remask";

export default ({ field, handleBlur, ...props }) => {
  const [state, setState] = useState(field.value || "");

  const handleChange = (e) => setState(unMask(e.target.value));

  return (
    <TextField
      fieldid={field.id}
      label={field.label}
      onChange={handleChange}
      onBlur={handleBlur}
      value={mask(state, ["999.999.999-99", "99.999.999/9999-99"])}
      variant="outlined"
      inputProps={{
        fieldid: field.id,
      }}
      InputProps={{
        endAdornment: field.updating ? (
          <InputAdornment position="end" className="p-12">
            <Icon className="fas fa-sync fa-spin m-color-blue" />
          </InputAdornment>
        ) : field.icon ? (
          <InputAdornment position="end" className="p-12">
            <Icon className={field.icon} />
          </InputAdornment>
        ) : null,
      }}
      {...props}
    />
  );
};
